import React from 'react';

export default function FwMailIcon({
  color = 'currentColor',
  fontSize = '16px',
}) {
  return (
    <>
      <i className='fas fa-inbox' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
